/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Exhaustairco2defect4Inputs */



/**
* | output |
* | --- |
* | "Exhaust air CO2 sensor fault" |
*
* @param {Ahu_History_Key_Exhaustairco2defect4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_exhaustairco2defect4 = /** @type {((inputs?: Ahu_History_Key_Exhaustairco2defect4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Exhaustairco2defect4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Exhaust air CO2 sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde CO2 air rejeté")
});
export { ahu_history_key_exhaustairco2defect4 as "ahu_history_key_exhaustAirCO2Defect" }